
function showTab1() {

document.getElementById("tab2-content").style.display ="none";
document.getElementById("tab3-content").style.display ="none";
document.getElementById("tab2-title").style.backgroundColor = "white";
document.getElementById("tab2-title").style.color = "#121212";
document.getElementById("tab3-title").style.backgroundColor = "white";
document.getElementById("tab3-title").style.color = "#121212";
document.getElementById("tab1-content").style.display ="Block";
document.getElementById("tab1-title").style.backgroundColor = "black";
document.getElementById("tab1-title").style.color = "white";
}
function showTab2() {
   
document.getElementById("tab1-content").style.display ="none";
document.getElementById("tab3-content").style.display ="none";
document.getElementById("tab1-title").style.backgroundColor = "white";
document.getElementById("tab1-title").style.color = "#121212";
document.getElementById("tab3-title").style.backgroundColor = "white";
document.getElementById("tab3-title").style.color = "#121212";
document.getElementById("tab2-content").style.display ="Block";
document.getElementById("tab2-title").style.backgroundColor = "black";
document.getElementById("tab2-title").style.color = "white";
}
function showTab3() {
  
document.getElementById("tab1-content").style.display ="none";
document.getElementById("tab2-content").style.display ="none";
document.getElementById("tab1-title").style.backgroundColor = "white";
document.getElementById("tab1-title").style.color = "#121212";
document.getElementById("tab2-title").style.backgroundColor = "white";
document.getElementById("tab2-title").style.color = "#121212";
document.getElementById("tab3-content").style.display ="Block";
document.getElementById("tab3-title").style.backgroundColor = "black";
document.getElementById("tab3-title").style.color = "white";
}

document.getElementById("tab1-title").onclick = function() {showTab1()};
document.getElementById("tab2-title").onclick = function() {showTab2()};
document.getElementById("tab3-title").onclick = function() {showTab3()};
